// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_form__-7gN\\+ > div:last-child {
  position: relative;
  box-shadow: none;
  border: none; }
`, "",{"version":3,"sources":["webpack://./src/modules/booths/components/screens/CreateBoothScreen/styles.module.scss"],"names":[],"mappings":"AAAA;EAGQ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY,EAAA","sourcesContent":[".form {\n    // border: 1px solid red;\n    & > div:last-child {\n        position: relative;\n        box-shadow: none;\n        border: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `styles_form__-7gN+`
};
export default ___CSS_LOADER_EXPORT___;
